import React from 'react';
import PropTypes from 'prop-types';
import Message from '../message/Message';

const PlayerStars = ({goldStars, blueStars}) => {
    return (
        <div className="rankRow">
            <div className="statColumn"><Message code="epic.ut.stats.challenge_stars" /></div>
            <div className="xpDataColumn">
                <div className="challengeValue">{goldStars}</div>
                <div className="challengeStar1" />
                <div className="challengeValue">{blueStars}</div>
                <div className="challengeStar2" />
            </div>
        </div>
    )
}

PlayerStars.propTypes = {
    goldStars: PropTypes.number,
    blueStars: PropTypes.number
}

export default PlayerStars
